module.exports = __webpack_public_path__ + "static/img/mision.f4a1452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mision.png
// module id = YiIE
// module chunks = 1